(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Halloween-game"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const gameContainer = document.getElementById('halloween-game-container');
    if (gameContainer) {
      gameContainer.style.opacity = 1;
    }
    
    const productsData = JSON.parse(document.getElementById('game-data').textContent);
    const playButton = document.getElementById('playButton');

    if (!productsData || productsData.length === 0) {
      if(playButton) {
        playButton.disabled = true;
        playButton.classList.remove('spooky-glow', 'hover:bg-orange-700');
        playButton.classList.add('bg-gray-600', 'cursor-not-allowed');
      }
      console.warn('Halloween Game: No prize blocks configured. Game is disabled.');
      return;
    }
    
    const result = document.getElementById('result');
    const loading = document.getElementById('loading');
    const winnerProduct = document.getElementById('winnerProduct');
    let isPlaying = false;
    let lastWinner = -1;
    let hasPlayed = sessionStorage.getItem('halloweenGamePlayed_v2') === 'true';

    function updateButtonState() {
      if (!playButton) return;
      if (hasPlayed) {
        playButton.disabled = true;
        playButton.classList.remove('hover:bg-orange-700', 'hover:scale-105', 'spooky-glow');
        playButton.classList.add('bg-gray-600', 'cursor-not-allowed');
        playButton.textContent = 'Bereits gespielt! 🎃';
      }
    }

    updateButtonState();
    playButton.addEventListener('click', startGame);

    function restartGame() {
      console.log('CHEAT ACTIVATED: Game has been reset.');
      hasPlayed = false;
      isPlaying = false;
      sessionStorage.removeItem('halloweenGamePlayed_v2');
      
      result.classList.add('hidden');
      loading.classList.add('hidden');
      
      document.querySelectorAll('.product-card').forEach(card => card.classList.remove('winner-glow'));
      
      if (playButton) {
        playButton.disabled = false;
        playButton.classList.remove('bg-gray-600', 'cursor-not-allowed');
        playButton.classList.add('hover:bg-orange-700', 'hover:scale-105', 'spooky-glow');
        playButton.innerHTML = playButton.dataset.defaultText;
      }
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === '0') {
        restartGame();
      }
    });

    window.copyCode = function(button, code) {
      navigator.clipboard.writeText(code).then(() => {
        const originalText = button.innerHTML;
        button.innerHTML = '✅ Kopiert!';
        const originalBgColor = button.style.backgroundColor;
        button.style.backgroundColor = '#16a34a'; 

        setTimeout(() => {
          button.innerHTML = originalText;
          button.style.backgroundColor = originalBgColor;
        }, 2000);
      }).catch(err => {
        console.error("Fehler beim Kopieren des Codes: ", err);
        button.innerHTML = 'Fehler!';
        setTimeout(() => {
          button.innerHTML = '📋 Code kopieren';
        }, 2000);
      });
    }

    function startGame() {
      if (isPlaying || hasPlayed) return;

      isPlaying = true;
      hasPlayed = true;
      sessionStorage.setItem('halloweenGamePlayed_v2', 'true');
      updateButtonState();

      result.classList.add('hidden');
      loading.classList.remove('hidden');

      document.querySelectorAll('.product-card').forEach(card => card.classList.remove('winner-glow'));

      let finalWinner;
      do {
        finalWinner = Math.floor(Math.random() * productsData.length);
      } while (finalWinner === lastWinner && productsData.length > 1 && Math.random() < 0.7);

      lastWinner = finalWinner;

      let currentIndex = 0;
      let rounds = 0;
      const maxRounds = 3 + Math.floor(Math.random() * 3);

      function lightUpNext() {
        document.querySelectorAll('.product-card').forEach(card => card.classList.remove('light-up'));
        
        const currentCard = document.getElementById(`product-${currentIndex}`);
        if (currentCard) currentCard.classList.add('light-up');
        
        const isFinalRound = rounds >= maxRounds;
        const hasReachedWinner = currentIndex === finalWinner;

        if (isFinalRound && hasReachedWinner) {
          setTimeout(() => {
            document.querySelectorAll('.product-card').forEach(card => card.classList.remove('light-up'));
            const winnerCard = document.getElementById(`product-${finalWinner}`);
            if (winnerCard) winnerCard.classList.add('winner-glow');
            
            const winner = productsData[finalWinner];
            showWinner(winner);
            isPlaying = false;
          }, 500);
          return;
        }

        currentIndex = (currentIndex + 1) % productsData.length;
        if (currentIndex === 0) {
            rounds++;
        }
        
        const delay = rounds < maxRounds - 1 ? 150 : 350 + (rounds * 50);
        setTimeout(lightUpNext, delay);
      }
      
      setTimeout(lightUpNext, 500);
    }

    function showWinner(winner) {
      loading.classList.add('hidden');
      
      // ÄNDERUNG HIER: Code-Box-Styling vereinfacht, da die Eltern-Box den Effekt hat.
      winnerProduct.innerHTML = `
        <img src="${winner.image}" alt="${winner.name}" class="w-40 h-40 object-contain mx-auto mb-4" width="160" height="160" loading="lazy">
        <div class="text-3xl font-bold" style="color: ${winner.color};">${winner.name}</div>
        
        <div class="text-xl text-gray-800 mt-6">Dein Rabattcode:</div>
        <div class="text-4xl font-bold mt-2 p-3 rounded-lg inline-block text-gray-900" style="background-color: rgba(0,0,0,0.05);">
            ${winner.code}
        </div>

        <button onclick="copyCode(this, '${winner.code}')" class="mt-6 text-white px-8 py-3 rounded-lg font-bold transition-all duration-300 text-lg block mx-auto" style="background-color: ${winner.color};">
          📋 Code kopieren
        </button>
      `;
      
      result.classList.remove('hidden');
      createConfetti();
    }

    function createConfetti() {
        const confettiEmojis = ['🎃', '👻', '🦇', '🕷️', '🍭', '🎉', '✨'];
        const confettiContainer = document.querySelector('.halloween-game-wrapper') || document.body;
        for (let i = 0; i < 60; i++) {
            setTimeout(() => {
                const confetti = document.createElement('div');
                confetti.innerHTML = confettiEmojis[Math.floor(Math.random() * confettiEmojis.length)];
                confetti.style.position = 'absolute';
                confetti.style.left = Math.random() * 100 + '%';
                confetti.style.top = '-50px';
                confetti.style.fontSize = (2 + Math.random() * 2) + 'rem';
                confetti.style.zIndex = '1000';
                confetti.style.pointerEvents = 'none';
                confetti.style.animation = `fall ${4 + Math.random() * 3}s linear forwards`;
                confettiContainer.appendChild(confetti);
                setTimeout(() => confetti.remove(), 7000);
            }, i * 50);
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airrush-hero-starterpack"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observers = new WeakMap();

  function initReveal(section){
    if (!section || !section.classList.contains('animate-reveal')) return;
    const once = section.dataset.revealOnce === 'true';

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-inview');
      return;
    }
    if (observers.has(section)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add('is-inview');
          if (once) observer.unobserve(section);
        } else if (!once) {
          section.classList.remove('is-inview');
        }
      });
    }, { threshold: 0.2 });

    observers.set(section, observer);
    requestAnimationFrame(() => observer.observe(section));
  }

  function initAll(){ document.querySelectorAll('.ar-flex-section').forEach(initReveal); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Für Theme-Editor, wenn Abschnitte neu geladen werden
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target && (e.target.querySelector('.ar-flex-section') || e.target);
    if (el && el.classList && el.classList.contains('ar-flex-section')) initReveal(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqSections = document.querySelectorAll('.faq-section');
    faqSections.forEach(section => {
      const faqContainer = section.querySelector('.faq-container');
      if (!faqContainer) return;
      function toggleFAQ(button) {
        const answer = button.nextElementSibling;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const allButtons = faqContainer.querySelectorAll('.faq-question');
        allButtons.forEach(btn => {
          if (btn !== button) {
            btn.classList.remove('active');
            btn.setAttribute('aria-expanded', 'false');
            btn.nextElementSibling.classList.remove('active');
          }
        });
        button.classList.toggle('active', !isExpanded);
        button.setAttribute('aria-expanded', !isExpanded);
        answer.classList.toggle('active', !isExpanded);
      }
      faqContainer.addEventListener('click', function(event) {
        const button = event.target.closest('.faq-question');
        if (button) {
          toggleFAQ(button);
        }
      });
      const faqItems = faqContainer.querySelectorAll('.faq-item');
      faqItems.forEach((item, index) => {
        item.style.animation = `fadeIn 0.6s ease-out ${index * 0.1}s both`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-probier-hero"] && !Shopify.designMode) return;
  try {
    
  /* Intentionally empty – JS ist im Markup enthalten (scoped) */

  } catch(e) { console.error(e); }
})();
})();
